import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  pt: {
    // Landing
    hero_badge: "Inteligência Artificial para Imigração",
    hero_title: "Seu Caminho Legal para a",
    hero_title_highlight: "Espanha",
    hero_subtitle: "Análise personalizada do seu caso migratório com IA. Descubra as rotas legais, documentos necessários e cronograma para sua regularização na Espanha.",
    hero_cta: "Iniciar Análise",
    hero_how: "Como funciona",
    
    // Features
    features_title: "Como Funciona",
    features_subtitle: "Análise Completa em Minutos",
    features_description: "Nossa IA analisa seu caso e gera um relatório profissional com tudo que você precisa saber.",
    
    feature_1_title: "Análise Instantânea",
    feature_1_desc: "IA analisa seu caso em segundos e identifica as melhores rotas legais.",
    feature_2_title: "Fontes Oficiais",
    feature_2_desc: "Baseado em legislação atual e fontes governamentais verificadas.",
    feature_3_title: "Cronograma Personalizado",
    feature_3_desc: "Plano de ação detalhado para 7, 14 e 30 dias.",
    feature_4_title: "Checklist Completo",
    feature_4_desc: "Lista de documentos necessários para cada membro da família.",
    feature_5_title: "Suporte Especializado",
    feature_5_desc: "Acesso direto a consultores via WhatsApp para próximos passos.",
    feature_6_title: "PDF Premium",
    feature_6_desc: "Relatório profissional para apresentar onde necessário.",
    
    // Process
    process_title: "Processo",
    process_subtitle: "3 Passos Simples",
    step_1_title: "Preencha o Formulário",
    step_1_desc: "Responda algumas perguntas sobre sua situação atual e objetivos migratórios.",
    step_2_title: "Receba a Análise",
    step_2_desc: "Nossa IA analisa seu caso instantaneamente conectando às fontes oficiais.",
    step_3_title: "Obtenha o Relatório",
    step_3_desc: "Acesse o relatório completo com checklist, cronograma e fontes oficiais.",
    
    // Pricing
    pricing_title: "Pronto para Descobrir seu Caminho?",
    pricing_subtitle: "Receba um relatório estratégico completo com análise técnica personalizada do seu caso migratório.",
    pricing_badge: "Análise Técnica Personalizada",
    pricing_product: "Relatório Estratégico",
    pricing_product_desc: "Documento técnico completo",
    pricing_investment: "Investimento único",
    pricing_item_1: "Avaliação preliminar gratuita",
    pricing_item_2: "Análise completa com IA especializada",
    pricing_item_3: "Rotas legais e documentação necessária",
    pricing_item_4: "PDF profissional para download",
    pricing_item_5: "Suporte via WhatsApp",
    
    // Testimonials
    testimonials_title: "Depoimentos",
    testimonials_subtitle: "O Que Nossos Clientes Dizem",
    
    // Footer
    footer_disclaimer: "Este serviço não constitui aconselhamento jurídico formal. Consulte sempre um profissional habilitado.",
    
    // Wizard
    wizard_step: "Etapa",
    wizard_of: "de",
    wizard_continue: "Continuar",
    wizard_back: "Voltar",
    wizard_submit: "Gerar Análise",
    wizard_analyzing: "Analisando...",
    
    // Preview/Report
    preview_success: "Análise Preliminar Concluída",
    preview_greeting: "sua avaliação inicial está disponível.",
    get_report: "Obter Relatório Completo",
    download_pdf: "Baixar PDF",
    talk_support: "Falar com Suporte",
    advance_service: "Avançar com Serviço",
    your_code: "Seu Código",
    select_service: "Selecionar serviço",
    next_steps: "Próximos Passos"
  },
  es: {
    hero_badge: "Inteligencia Artificial para Inmigración",
    hero_title: "Tu Camino Legal hacia",
    hero_title_highlight: "España",
    hero_subtitle: "Análisis personalizado de tu caso migratorio con IA. Descubre las rutas legales, documentos necesarios y cronograma para tu regularización en España.",
    hero_cta: "Iniciar Análisis",
    hero_how: "Cómo funciona",
    
    features_title: "Cómo Funciona",
    features_subtitle: "Análisis Completo en Minutos",
    features_description: "Nuestra IA analiza tu caso y genera un informe profesional con todo lo que necesitas saber.",
    
    feature_1_title: "Análisis Instantáneo",
    feature_1_desc: "IA analiza tu caso en segundos e identifica las mejores rutas legales.",
    feature_2_title: "Fuentes Oficiales",
    feature_2_desc: "Basado en legislación actual y fuentes gubernamentales verificadas.",
    feature_3_title: "Cronograma Personalizado",
    feature_3_desc: "Plan de acción detallado para 7, 14 y 30 días.",
    feature_4_title: "Checklist Completo",
    feature_4_desc: "Lista de documentos necesarios para cada miembro de la familia.",
    feature_5_title: "Soporte Especializado",
    feature_5_desc: "Acceso directo a consultores vía WhatsApp para próximos pasos.",
    feature_6_title: "PDF Premium",
    feature_6_desc: "Informe profesional para presentar donde sea necesario.",
    
    process_title: "Proceso",
    process_subtitle: "3 Pasos Simples",
    step_1_title: "Completa el Formulario",
    step_1_desc: "Responde algunas preguntas sobre tu situación actual y objetivos migratorios.",
    step_2_title: "Recibe el Análisis",
    step_2_desc: "Nuestra IA analiza tu caso instantáneamente conectando a las fuentes oficiales.",
    step_3_title: "Obtén el Informe",
    step_3_desc: "Accede al informe completo con checklist, cronograma y fuentes oficiales.",
    
    pricing_title: "¿Listo para Descubrir tu Camino?",
    pricing_subtitle: "Recibe un informe estratégico completo con análisis técnico personalizado de tu caso migratorio.",
    pricing_badge: "Análisis Técnico Personalizado",
    pricing_product: "Informe Estratégico",
    pricing_product_desc: "Documento técnico completo",
    pricing_investment: "Inversión única",
    pricing_item_1: "Evaluación preliminar gratuita",
    pricing_item_2: "Análisis completo con IA especializada",
    pricing_item_3: "Rutas legales y documentación necesaria",
    pricing_item_4: "PDF profesional para descargar",
    pricing_item_5: "Soporte vía WhatsApp",
    
    testimonials_title: "Testimonios",
    testimonials_subtitle: "Lo Que Dicen Nuestros Clientes",
    
    footer_disclaimer: "Este servicio no constituye asesoramiento jurídico formal. Consulte siempre a un profesional habilitado.",
    
    wizard_step: "Paso",
    wizard_of: "de",
    wizard_continue: "Continuar",
    wizard_back: "Volver",
    wizard_submit: "Generar Análisis",
    wizard_analyzing: "Analizando...",
    
    preview_success: "Análisis Preliminar Completado",
    preview_greeting: "tu evaluación inicial está disponible.",
    get_report: "Obtener Informe Completo",
    download_pdf: "Descargar PDF",
    talk_support: "Hablar con Soporte",
    advance_service: "Avanzar con Servicio",
    your_code: "Tu Código",
    select_service: "Seleccionar servicio",
    next_steps: "Próximos Pasos"
  },
  en: {
    hero_badge: "Artificial Intelligence for Immigration",
    hero_title: "Your Legal Path to",
    hero_title_highlight: "Spain",
    hero_subtitle: "Personalized analysis of your immigration case with AI. Discover legal routes, required documents and timeline for your regularization in Spain.",
    hero_cta: "Start Analysis",
    hero_how: "How it works",
    
    features_title: "How It Works",
    features_subtitle: "Complete Analysis in Minutes",
    features_description: "Our AI analyzes your case and generates a professional report with everything you need to know.",
    
    feature_1_title: "Instant Analysis",
    feature_1_desc: "AI analyzes your case in seconds and identifies the best legal routes.",
    feature_2_title: "Official Sources",
    feature_2_desc: "Based on current legislation and verified government sources.",
    feature_3_title: "Personalized Timeline",
    feature_3_desc: "Detailed action plan for 7, 14 and 30 days.",
    feature_4_title: "Complete Checklist",
    feature_4_desc: "List of required documents for each family member.",
    feature_5_title: "Specialized Support",
    feature_5_desc: "Direct access to consultants via WhatsApp for next steps.",
    feature_6_title: "Premium PDF",
    feature_6_desc: "Professional report to present where needed.",
    
    process_title: "Process",
    process_subtitle: "3 Simple Steps",
    step_1_title: "Fill Out the Form",
    step_1_desc: "Answer some questions about your current situation and immigration goals.",
    step_2_title: "Receive the Analysis",
    step_2_desc: "Our AI analyzes your case instantly connecting to official sources.",
    step_3_title: "Get the Report",
    step_3_desc: "Access the complete report with checklist, timeline and official sources.",
    
    pricing_title: "Ready to Discover Your Path?",
    pricing_subtitle: "Receive a complete strategic report with personalized technical analysis of your immigration case.",
    pricing_badge: "Personalized Technical Analysis",
    pricing_product: "Strategic Report",
    pricing_product_desc: "Complete technical document",
    pricing_investment: "One-time investment",
    pricing_item_1: "Free preliminary evaluation",
    pricing_item_2: "Complete analysis with specialized AI",
    pricing_item_3: "Legal routes and required documentation",
    pricing_item_4: "Professional PDF for download",
    pricing_item_5: "WhatsApp support",
    
    testimonials_title: "Testimonials",
    testimonials_subtitle: "What Our Clients Say",
    
    footer_disclaimer: "This service does not constitute formal legal advice. Always consult a qualified professional.",
    
    wizard_step: "Step",
    wizard_of: "of",
    wizard_continue: "Continue",
    wizard_back: "Back",
    wizard_submit: "Generate Analysis",
    wizard_analyzing: "Analyzing...",
    
    preview_success: "Preliminary Analysis Completed",
    preview_greeting: "your initial evaluation is available.",
    get_report: "Get Complete Report",
    download_pdf: "Download PDF",
    talk_support: "Talk to Support",
    advance_service: "Proceed with Service",
    your_code: "Your Code",
    select_service: "Select service",
    next_steps: "Next Steps"
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('legislai_lang') || 'pt';
    }
    return 'pt';
  });

  useEffect(() => {
    localStorage.setItem('legislai_lang', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.pt[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
